import { render, staticRenderFns } from "./objectAdmin.vue?vue&type=template&id=6290958e"
import script from "./objectAdmin.vue?vue&type=script&lang=js"
export * from "./objectAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6290958e')) {
      api.createRecord('6290958e', component.options)
    } else {
      api.reload('6290958e', component.options)
    }
    module.hot.accept("./objectAdmin.vue?vue&type=template&id=6290958e", function () {
      api.rerender('6290958e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectAdmin.vue"
export default component.exports